export default class RegistrationHelp {
    public init(): void {
        const helpIcons = jq(".tab-help, .external-contact-help");
        helpIcons.tooltip();
        helpIcons.on("click", (event: JQuery.ClickEvent) => {
            jq(event.currentTarget).tooltip("toggle");
            event.stopPropagation();
        });

        jq(document.documentElement).on("click", (event: JQuery.ClickEvent) => {
            helpIcons.tooltip("hide");
        });

        const cardHelpIcons = jq(".card-help");
        cardHelpIcons.on("click", (event) => this.cardHelpHandler(event, cardHelpIcons));
    }

    private cardHelpHandler(event: JQuery.ClickEvent, cardHelpIcons: JQuery): void {
        const eventTargetJq = jq(event.currentTarget);
        const exampleCardContainer = eventTargetJq.parents("form").find(".example-card-container");
        if (eventTargetJq.hasClass("selected")) {
            eventTargetJq.removeClass("selected");
            exampleCardContainer.empty();
        } else {
            const exampleCardUrl = eventTargetJq.attr("data-example-card");
            exampleCardContainer.html(`<img src="${exampleCardUrl}" class="example-card-img"/>`);
            cardHelpIcons.removeClass("selected");
            eventTargetJq.addClass("selected");
        }
    }
}
